import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgEdit = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		d: "M7.5 14.748C7.5 14.2487 7.5 13.999 7.55641 13.7641C7.60642 13.5558 7.6889 13.3566 7.80083 13.174C7.92708 12.968 8.10362 12.7914 8.4567 12.4383L18.2178 2.67726C19.0634 1.83165 20.4344 1.83165 21.28 2.67726C22.1256 3.52287 22.1256 4.89388 21.28 5.73949L11.5189 15.5006C11.1659 15.8536 10.9893 16.0302 10.7833 16.1564C10.6007 16.2684 10.4015 16.3509 10.1932 16.4009C9.95827 16.4573 9.7086 16.4573 9.20928 16.4573H7.5V14.748Z",
		stroke: "currentColor",
		strokeWidth: 2,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	}), /* @__PURE__ */ _jsx("path", {
		d: "M3 18L3 19C3 20.1046 3.89543 21 5 21L19 21C20.1046 21 21 20.1046 21 19L21 18",
		stroke: "currentColor",
		strokeWidth: 2,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})]
});
export default SvgEdit;
